module.exports = __webpack_public_path__ + "4efa1a0bb8d2860aa9cb87aaf079e569.png";